import defined from './defined';

export default function valueOrDefault(value, defaultValue) {
    return defined(value) ? value : defaultValue;
}


// WEBPACK FOOTER //
// ./node_modules/@progress/kendo-drawing/dist/es/util/value-or-default.js